// Variáveis CSS também atualizam estilos definidos fora dos componentes React.
// Os fallbacks preservam o tema escuro em páginas independentes e nos previews.
export const C = {
  bg: "var(--pc-bg, #0d0f14)", panel: "var(--pc-panel, #161a23)",
  card: "var(--pc-card, #1e2433)", border: "var(--pc-border, #2a3148)",
  accent: "var(--pc-accent, #ff6b35)", accent2: "var(--pc-accent2, #00d4aa)",
  accent3: "var(--pc-accent3, #7b5ea7)", text: "var(--pc-text, #e8ecf4)",
  muted: "var(--pc-muted, #7a8499)", danger: "var(--pc-danger, #ff4757)",
  success: "var(--pc-success, #2ed573)", warning: "var(--pc-warning, #ffa502)",
};

// Substitui a concatenação de alpha hexadecimal, que não funciona com var().
export function withAlpha(color, alpha) {
  if (/^#[\da-f]{6}$/i.test(color)) return color + alpha;
  return `color-mix(in srgb, ${color} ${Math.round(parseInt(alpha, 16) / 255 * 10000) / 100}%, transparent)`;
}
